import { useState, useCallback } from "react"

export const useUndoRedo = (initialState = []) => {
  const [state, setState] = useState(initialState)
  const [history, setHistory] = useState([])
  const [redoStack, setRedoStack] = useState([])

  const set = useCallback((newState) => {
    setHistory((prev) => [...prev, state])
    setRedoStack([])
    setState(newState)
  }, [state])

  const undo = useCallback(() => {
    if (history.length === 0) return
    const prev = history.at(-1)
    setRedoStack((r) => [...r, state])
    setState(prev)
    setHistory((h) => h.slice(0, -1))
  }, [history, state])

  const redo = useCallback(() => {
    if (redoStack.length === 0) return
    const next = redoStack.at(-1)
    setHistory((h) => [...h, state])
    setState(next)
    setRedoStack((r) => r.slice(0, -1))
  }, [redoStack, state])

  const reset = useCallback(() => {
    setState(initialState)
    setHistory([])
    setRedoStack([])
  }, [initialState])

  return {
    state,
    set,
    undo,
    redo,
    reset,
    canUndo: history.length > 0,
    canRedo: redoStack.length > 0
  }
}
